// extracted by mini-css-extract-plugin
module.exports = {"content":"FeedbackModal_content__1wEKU","title":"FeedbackModal_title__2Q3Rq","category":"FeedbackModal_category__1ocpO","feedback":"FeedbackModal_feedback__3T143"};